const dataNavbar = [
    {
        to: '/',
        class: 'home',
        title: 'HOME'
    },
    {
        to: '/',
        class: 'brand',
        title: 'THEA'
    },
    {
        to: '/shop',
        class: 'shop',
        title: 'SHOP'
    }
]
export default dataNavbar;